import { provideEffects } from '@ngrx/effects';

import { ManagedSettingsEffects } from './managed-settings.effects';

export const provideManagedSettingsStore = () => [provideEffects([ManagedSettingsEffects])];
